import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { WindowServiceInjector, WindowService } from '@next/core-lib/window';

import { mestplaceTermsAndConditionsAcceptedCookie } from '../../cookies';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  standalone: false,
})
export class TermsAndConditionsComponent extends AbstractDialog<AbstractDialogData> {
  private readonly window = inject<WindowService>(WindowServiceInjector);
  protected mdDialogRef =
    inject<MatDialogRef<TermsAndConditionsComponent, AbstractDialogResultData<AbstractDialogData>>>(
      MatDialogRef,
    );
  data = inject<AbstractDialogData>(MAT_DIALOG_DATA);

  confirm() {
    this.window.setPlatformCookie(mestplaceTermsAndConditionsAcceptedCookie, 'true');
    this.mdDialogRef.close();
  }
}
